var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 25,
    viewBox: "0 0 112 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2304 11.084L15.6354 20.7161H11.0997L10.2416 19.1877H3.98965L3.13154 20.7161H0L5.40776 11.084H10.2304ZM9.02965 17.0147L7.12398 13.6144L5.21552 17.0147H9.02965Z",
    fill: "#232629"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8762 11.9873V19.3929H29.788V21.6222H17.4634V11.9873H21.8762Z",
    fill: "#232629"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1545 12.5505V19.9562H43.0691V22.1854H30.7417V12.5505H35.1545Z",
    fill: "#232629"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7829 15.3423H50.2472V22.7479H45.8341V15.3423H41.2983V13.113H54.7829V15.3423Z",
    fill: "#232629"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7495 23.3109V13.676H68.0769V15.7955H60.1623V17.4337H67.3804L67.0266 19.4238H60.1623V20.9522H68.0769V23.3053L55.7495 23.3109Z",
    fill: "#232629"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2314 23.8739H69.4453V14.239H74.6664L80.6063 20.8734V14.239H83.3924V23.8739H78.1574L72.2314 17.2395V23.8739Z",
    fill: "#232629"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8386 17.0313H93.3029V24.4369H88.8897V17.0313H84.354V14.802H97.8386V17.0313Z",
    fill: "#232629"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M106.584 15.3652L112 25.0001H107.453L106.595 23.4717H100.343L99.4851 25.0001H96.3535L101.761 15.3652H106.584ZM105.383 21.2959L103.477 17.8985L101.569 21.2959H105.383Z",
    fill: "#232629"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12945 8.14796C5.95393 7.18532 28.1227 -1.40532 56.0753 0.199093C81.4286 1.65151 107.361 11.2442 106.943 13.4453C106.879 13.7887 106.177 13.9295 105.673 14.0083C94.0188 15.8576 60.7531 6.03971 55.9416 4.7027C29.1145 -2.74514 6.29105 9.13313 6.12945 8.14796Z",
    fill: "#232629"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.272f6f051ad2c24038ea4a2af15230c2.svg";
export { ForwardRef as ReactComponent };